import { useMemo } from 'react';
import { createProjectNumberFormatter } from 'utils';
import useProject from './use';

export default function useProjectNumberFormatter() {
  const { state } = useProject();

  return useMemo(
    () => createProjectNumberFormatter(state.decimalSeparator, state.thousandsSeparator),
    [state.decimalSeparator, state.thousandsSeparator],
  );
}
